import styled from 'styled-components';
export const NameCell = styled.div `
  width: ${({ inheritWidth }) => (inheritWidth ? 'inherit' : 'unset')};
  white-space: nowrap;
  text-align: ${({ typeAlignment }) => typeAlignment};
  text-overflow: ellipsis;
  overflow: hidden;
  // There might be addtional div inside NameCell with dangerouslySetInnerHTML attr
  > div {
    width: ${({ inheritWidth }) => (inheritWidth ? 'inherit' : 'unset')};
    white-space: nowrap;
    text-align: ${({ typeAlignment }) => typeAlignment};
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
